import { unknown } from './unknown';
export var blockCard = function (node) {
    if (!node.attrs.url) {
        return unknown(node);
    }
    return "[" + node.attrs.url + "|" + node.attrs.url + "|smart-card]";
};
//# sourceMappingURL=block-card.js.map